import { inject, Injectable } from '@angular/core';

import { AuthState } from '../auth.state';

import { SonaAuthFacade } from './auth.facade';

/**
 * A facade for the change-password feature
 */
@Injectable({
    providedIn: 'root'
})
export class SonaAuthChangePasswordFacade {

    /**
     * The user of the authenticated session
     */
    public static user = AuthState.user;

    private readonly _authFacade = inject(SonaAuthFacade);

    changePassword(newPassword: string) {
        return this._authFacade.changeUserPassword(newPassword);
    }
}
